import { createFileRoute } from '@tanstack/react-router'
import { ManufacturerDetailPage } from '@/pages/manufacturer-detail'

export const Route = createFileRoute('/_authenticated/manufacturers/$manuId')({
  staticData: { title: 'Manufacturer' },
  component: ManufacturerDetailRoute,
  // ``tab`` opens a tab; on the Emails tab (USA-1474) ``message`` opens the conversation at an email,
  // ``thread`` a conversation, and ``action`` brings an item opened from the Action Items page into view.
  validateSearch: (
    search: Record<string, unknown>,
  ): { tab?: string; message?: string; thread?: string; action?: string } => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    message:
      typeof search.message === 'string' || typeof search.message === 'number' ? String(search.message) : undefined,
    thread: typeof search.thread === 'string' ? search.thread : undefined,
    action: typeof search.action === 'string' ? search.action : undefined,
  }),
})

function ManufacturerDetailRoute() {
  const { manuId } = Route.useParams()
  const { tab, message, thread, action } = Route.useSearch()
  return (
    <ManufacturerDetailPage
      manuId={manuId}
      tab={tab}
      messageId={message ? Number(message) : undefined}
      threadUuid={thread}
      actionUuid={action}
    />
  )
}
